import { Button, Card } from "antd";
import notFoundImage from "assets/404.png";
import { useNavigate } from "react-router-dom";
import classes from "./styles.module.css";

export const PageNotFoundScreen: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={classes.mainContainer}>
      <Card
        className={classes.card}
        classNames={{
          body: classes.container
        }}
      >
        <div className={classes.imageContainer}>
          <img src={notFoundImage} alt="404-not-found" height={300} />
        </div>

        <h2 className={classes.infoTitle}>404 error</h2>
        <p className={classes.infoText}>
          Sorry the page you visited does not exist
        </p>

        <Button
          className={classes.actionButton}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => navigate(-1)}
        >Go to previous screen</Button>
      </Card>
    </div>
  );
};